/**
 * Flow — borang "Add customer" (admin): cara menghubungkan customer dengan akaun SESAAT.
 *
 * Keputusan user 3 Okt 2026: admin mengisi SALAH SATU — nombor WhatsApp ATAU email akaun
 * SESAAT (atau kedua-duanya). Ramai pelanggan belum mengisi nombor dalam akaun SESAAT, dan
 * ada yang admin hanya tahu emailnya. Sistem memadankan akaun ikut email dahulu, kemudian
 * nombor (server: `cariUidLangganan`).
 *
 * ⚠️ KEMBAR: functions/flowLanggananTulis.js `semakHubungan` — server menyemak sekali lagi
 *    dan ialah sumber kebenaran. Ubah peraturan / ayat di satu tempat → ubah yang satu lagi.
 */
export const EMEL_SAH = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Borang SATU kotak (10 Okt 2026 — dahulu dua kotak berlabel silang, admin menaip email dalam
 * kotak nombor dan ditolak). Ada '@' → email; selainnya → nombor WhatsApp. Maklumat yang satu
 * lagi diisi server daripada akaun SESAAT yang padan (functions/flowLangganan.js `butirAkaun`).
 * @param {string} mentah  apa yang admin taip
 * @returns {{ phone: string, email: string }}  nilai mentah untuk `semakHubungan`
 */
export function pecahHubungan(mentah) {
    const v = String(mentah ?? '').trim();
    return v.includes('@') ? { phone: '', email: v } : { phone: v, email: '' };
}

/**
 * @param {{ phone?: string, email?: string }} borang  nilai mentah dari borang
 * @returns {{ phone: string, email: string, ralat: string }}  phone = digit sahaja · ralat '' = lulus
 */
export function semakHubungan(borang) {
    const mentah = String(borang?.phone ?? '').trim();
    const phone = mentah.replace(/\D/g, '');
    const email = String(borang?.email ?? '').trim().toLowerCase();
    let ralat = '';
    // Nombor yang DITAIP tetapi tidak sah ditolak — tidak dianggap "kosong" secara senyap.
    if (mentah && (phone.length < 8 || phone.length > 20)) ralat = 'Enter a valid WhatsApp number or email.';
    else if (email && (!EMEL_SAH.test(email) || email.length > 254)) ralat = 'That email does not look right.';
    else if (!phone && !email) ralat = 'Enter the customer\'s WhatsApp number or SESAAT account email — at least one.';
    return { phone, email, ralat };
}

/**
 * Ayat selepas Add (Type 1): akaun SESAAT dijumpai atau belum. Tanpa akaun yang padan, Session
 * Access tidak boleh diberi — admin mesti tahu SEKARANG, bukan kemudian di tab Session Access.
 * @param {{ adaAkaun?: boolean, via?: string }} hasil  jawapan server `tambah`
 * @returns {{ teks: string, amaran: boolean }}
 */
export function ayatPadanan(hasil) {
    if (!hasil || typeof hasil.adaAkaun !== 'boolean') return { teks: 'Customer added.', amaran: false };   // server lama (belum deploy)
    if (hasil.adaAkaun) {
        const cara = hasil.via === 'phone' ? ' by WhatsApp number' : hasil.via === 'email' ? ' by email' : '';
        return { teks: `Customer added — matched to their SESAAT account${cara}.`, amaran: false };
    }
    if (hasil.via === 'phone-ambiguous') {
        return { teks: 'Customer added, but more than one SESAAT account uses this WhatsApp number. Open the customer and save their SESAAT email so Flow access can be given.', amaran: true };
    }
    return { teks: 'Customer added, but no SESAAT account matches this email or WhatsApp number yet. Flow access cannot be given until one does — check the details, or ask the customer to sign up.', amaran: true };
}
